import React from 'react';
import LabSimService, { StateContext } from '../services/LabSimService';
import SupportBox from '../controls/SupportBox';
import SuccessPage from './SuccessPage';
import { Routes } from '../Routing';
import LoadingPage from './LoadingPage';
import GradingControl from '../controls/GradingControl';
import ModulePublishControl from '../controls/ModulePublishControl';
import PageFooter from '../partials/PageFooter';
import { createRef } from 'react';
import { T } from '@testout/labsim-ui-atomics';
import styles from './Certifications.module.less';
import PlatformHelper from '../helpers/PlatformHelper';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => React.createElement(Certifications, Object.assign({}, props, { context: stateContext })))));
var CertificationType;
(function (CertificationType) {
    CertificationType[CertificationType["Certification"] = 1] = "Certification";
    CertificationType[CertificationType["CompetencyAssessment"] = 2] = "CompetencyAssessment";
})(CertificationType || (CertificationType = {}));
class Certifications extends React.Component {
    constructor(props) {
        super(props);
        this._noSelectionIndicator = '0';
        this.contentItemsSubmitRef = createRef();
        this.selectProduct = (selectedExam) => {
            this.setState({
                createDisabled: !(selectedExam !== this._noSelectionIndicator && this.state.possiblePoints > 0),
                selectedExam: selectedExam,
            });
        };
        this.onContinue = () => {
            if (this.props.context.products && this.props.context.products.certificationExams) {
                const certArray = Array.from(this.getCertificationMapValues().values()).find((certificationExams) => {
                    const firstExam = certificationExams[0];
                    return (firstExam.certificationGuid + firstExam.isbn + firstExam.productVersionId ===
                        this.state.selectedExam);
                });
                let cert = null;
                if (certArray && certArray.length > 0) {
                    cert = certArray[0];
                }
                if (cert != null && cert) {
                    this.setState({ isCreating: true, isReadyToPost: false }, () => {
                        var _a, _b;
                        const selectedResources = {
                            isPublish: this.state.selectedToPublish,
                            productVersionId: (_a = cert === null || cert === void 0 ? void 0 : cert.productVersionId) !== null && _a !== void 0 ? _a : 0,
                            resources: [
                                {
                                    allowedAttempts: -1,
                                    assignmentGroup: this.state.selectedAssignmentGroup,
                                    assignmentType: 'certification',
                                    isGraded: this.state.isGraded,
                                    moduleGroup: this.state.selectedModule,
                                    pointsPossible: this.state.isGraded ? this.state.possiblePoints : 0,
                                    resourceGuid: (_b = cert === null || cert === void 0 ? void 0 : cert.certificationGuid) !== null && _b !== void 0 ? _b : '',
                                },
                            ],
                        };
                        LabSimService.createCertificationAssignment(selectedResources, (data) => this.createCallback(data), (err) => this.setState({ error: err, isCreating: false, isReadyToPost: false }));
                    });
                }
                else {
                    alert("We couldn't locate that class assessment. Please contact CompTIA support.");
                }
            }
        };
        this.goToHome = () => {
            this.props.history.push(Routes.HOME);
        };
        this.getCertificationMapValues = () => {
            const migratedToLockedProducts = this.props.context.getMigratedToLockedProducts();
            const migratedFromLockedProducts = this.props.context.getMigratedFromLockedProducts();
            const certificationExamMap = new Map();
            this.props.context
                .products.certificationExams.filter((certificationExam) => {
                return !migratedToLockedProducts.some((m) => m.isbn === certificationExam.isbn);
            })
                .filter((certificationExam) => {
                return !migratedFromLockedProducts.some((m) => m.isbn === certificationExam.isbn);
            })
                .forEach((certificationExam) => {
                const key = certificationExam.certificationGuid;
                if (!certificationExamMap.has(key)) {
                    certificationExamMap.set(key, []);
                }
                certificationExamMap.get(key).push(certificationExam);
            });
            return certificationExamMap;
        };
        this.state = {
            createDisabled: true,
            isCreating: false,
            isGraded: true,
            isReadyToPost: false,
            linkCreated: false,
            possiblePoints: 100,
            postParams: [],
            response: undefined,
            selectedExam: undefined,
            selectedModule: '',
            selectedToPublish: false,
        };
    }
    createCallback(response) {
        if (response.isValid &&
            this.props.context.isFamilyDesire2Learn() &&
            !this.props.context.isIntegrationLTIAdvantage()) {
            this.setState({ isCreating: false, isReadyToPost: false, response: response });
            if (response.redirectUrl !== 'undefined') {
                window.location.assign(response.redirectUrl);
            }
        }
        else if (response.error) {
            this.setState({ error: response.error, isCreating: false, isReadyToPost: false });
        }
        else {
            this.setState({ linkCreated: true, response: response }, () => {
                var _a;
                if (response.responseType === 2) {
                    (_a = this.contentItemsSubmitRef.current) === null || _a === void 0 ? void 0 : _a.click();
                }
            });
        }
    }
    getAssessmentType(type) {
        switch (type) {
            case CertificationType.CompetencyAssessment:
                return 'Competency Assessment';
            case CertificationType.Certification:
            default:
                return 'Certification';
        }
    }
    render() {
        if (this.state.linkCreated) {
            if (this.state.response != null && this.state.response.responseType === 2) {
                return (React.createElement("form", { name: 'contentItems', method: 'POST', action: this.state.response.redirectUrl },
                    React.createElement("input", { type: 'hidden', value: this.state.response.jwt, id: 'JWT', name: 'JWT' }),
                    React.createElement("input", { type: 'submit', value: 'Post', ref: this.contentItemsSubmitRef, hidden: true })));
            }
            return (React.createElement(SuccessPage, { successAction: React.createElement(React.Fragment, null, "Link to Pro Class Assessment Created"), moreInfo: this.state.isGraded ? (React.createElement(React.Fragment, null,
                    "Go to ",
                    React.createElement("i", null, "Assignments"),
                    " to find the links to CertMaster.")) : (React.createElement(React.Fragment, null,
                    "Go to ",
                    React.createElement("i", null, "Modules"),
                    " to find the links to CertMaster.")), onClickCallback: () => this.goToHome() }));
        }
        if (!this.state.isCreating && !this.state.isReadyToPost) {
            let products = [];
            if (this.props.context.productsLoaded &&
                this.props.context.products &&
                this.props.context.products.certificationExams) {
                products = Array.from(this.getCertificationMapValues().values()).map((certificationExams) => {
                    const firstExam = certificationExams[0];
                    const type = this.getAssessmentType(firstExam.certificationTypeId);
                    const consolidatedIsbns = certificationExams
                        .map((exam) => exam.isbn)
                        .sort()
                        .join(' / ');
                    return (React.createElement(T.Select.Option, { automationId: firstExam.title, key: firstExam.certificationGuid + firstExam.isbn, value: firstExam.certificationGuid + firstExam.isbn + firstExam.productVersionId },
                        firstExam.title,
                        " ",
                        type,
                        " (",
                        consolidatedIsbns,
                        ")"));
                });
            }
            return (React.createElement(StateContext.Consumer, null, (stateContext) => {
                if (!stateContext.productsLoaded)
                    return React.createElement(LoadingPage, { status: 'Loading Pro Certifications' });
                return (React.createElement("div", { className: styles.container },
                    React.createElement(T.Text.H1, { automationId: 'title' }, "Create Link to Class Assessments"),
                    React.createElement(T.Form, { onSubmit: this.onContinue, automationId: 'proCertForm', className: styles.form, onCancel: this.props.history.goBack },
                        React.createElement(T.Form.Field, { automationId: 'cert-select', required: true },
                            React.createElement(T.Form.Label, null, "Class Assessment"),
                            React.createElement(T.Form.Select, { placeholder: 'Select class assessment', onChange: this.selectProduct, value: this.state.selectedExam }, products)),
                        React.createElement(GradingControl, { defaultPointsPossible: this.state.possiblePoints, disabled: !this.state.isGraded, offText: PlatformHelper.getPlatform(stateContext.serverState).toLowerCase() === 'canvas'
                                ? 'This ungraded class assessment will only be available in modules.'
                                : '', onChange: (e) => {
                                this.setState({
                                    isGraded: !e.disabled,
                                    possiblePoints: e.value,
                                    selectedAssignmentGroup: e.assignment,
                                });
                            }, onReady: (e) => this.setState({ selectedAssignmentGroup: e.assignment }) }),
                        React.createElement(ModulePublishControl, { publishDefault: false, allowNoneOption: this.state.isGraded, onChange: (e) => {
                                this.setState({
                                    selectedModule: e.module,
                                    selectedToPublish: e.publishOnCreation,
                                });
                            }, onReady: (e) => this.setState({ selectedModule: e.module }) }),
                        React.createElement(T.Form.RequiredIndicator, null),
                        React.createElement(T.Form.Footer, null,
                            React.createElement(T.Form.Cancel, null, "Cancel"),
                            React.createElement(T.Form.Save, { disabled: this.state.createDisabled || !stateContext.canvasDataLoaded }, "Create"))),
                    this.state.error && (React.createElement(T.WarningDialog, { onClose: () => this.goToHome(), title: 'Error', automationId: 'error' },
                        this.state.error,
                        React.createElement(SupportBox, null))),
                    React.createElement(PageFooter, null)));
            }));
        }
        else if (this.state.isCreating) {
            return React.createElement(LoadingPage, { status: 'Creating link to Class Assessment' });
        }
        else if (this.state.isReadyToPost) {
            if (typeof this.state.postParams === 'undefined') {
                return React.createElement(LoadingPage, null);
            }
            else {
                // eslint-disable-next-line
                const formFields = this.state.postParams.map((pp) => {
                    // eslint-disable-line
                    return React.createElement("input", { type: 'hidden', name: pp.Key, value: pp.Value, key: pp.Key });
                });
                return (React.createElement(StateContext.Consumer, null, (stateContext) => {
                    return (React.createElement("div", { className: 'center' },
                        React.createElement("form", { action: stateContext.serverState.lmsApiDomain, method: 'POST' },
                            formFields,
                            React.createElement("button", { type: 'submit', className: 'to-button-Bright' }, "Create Link"))));
                }));
            }
        }
        else {
            return React.createElement(LoadingPage, null);
        }
    }
}
//# sourceMappingURL=Certifications.js.map